
import "C:/github-runners/esig-portal/_work/esig-client/esig-client/src/components/Form/styles.less?modules";
export default {"fullWidth": `fullWidth-AzIzX24d`,"inputClass": `inputClass-oAyM9dz8`,"error_message": `error_message-H5vpiOlH`,"fullDropdown": `fullDropdown-KEaB6y5n`,"buttonClass": `buttonClass-_RPPqBlU`,"show": `show-pDPNHrxr`}
